import { Data } from "@angular/router";
import { SimpleResponse } from "./genericResponse.model";
import { ContactHistory } from "./contactHistory.model";
import { eContactTxtMsgStatus, eSAMFieldStatus } from "./enum.model";
import { SearchQueryResponse } from "./search.model";
import { MatTableDataSource } from "@angular/material/table";
import { VoiceCallModel } from "./voiceCall.model";
import { ContactField } from "./contactField.model";

export interface ContactList {
    recentContactID: number;
    contactID: number;
    name: string;
    firstName: string;
    lastName: string;
    email: string;
    companyName: string;
    phone: string;
    searchablePhone: string;
    mobile: string;
    homePhone: string;
    add1: string;
    add2: string;
    add3: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    emailAddress: string;
    country: string;
    dtModified: Date;
    dtCreated: Data;
    dtModifiedDisplay: Date;
    dtCreatedDisplay: Date;
    userName: string;
    uFirstName: string;
    uLastName: string;
    clpUserId: number;
    class1Code: number;
    coCompanyType: number;
    coCompanyName: string;
    coCompanyID: number;
}

export interface ContactListResponse extends SimpleResponse {
    contactList: ContactList[];
}

export interface ContactMoreResponse extends SimpleResponse {
    contactMore: ContactMore;
}

export interface ContactMore {
    ContactID: number;
    customDate1Title: string;
    customDate2Title: string;
    customDate3Title: string;
    customDate1: Date;
    customDate2: Date;
    customDate3: Date;
    customText1: string;
    customText2: string;
    customText3: string;
}

export interface ContactFilters {
    FilterName: string;
    value: number;
    display: string;
    cLPCompanyID: number;
    sOrder: number
    strValue: string;
}

export enum eFieldType {
    Textbox = 0,
    CheckBox = 1,
    Dropdown = 2,
    None = 3,
    Combobox = 4,
    Date = 5,
    MultiLineTextbox = 6,
    MultiDropdown = 7,
    Label = 8
}

export interface Field<T> {
    fieldName: string;
    fieldValue: T;
    fieldTitle: string;
    fieldType: eFieldType;
    isShow: eFieldStatus;
    items: Filters[];
    isEditable: boolean;
    link: string;
    section: eSection;
    displayOrder: number;
    inputConfigFiled: string;
    sectionCompany: eSectionCompany;
    sectionLead: eSectionLead;
}

export enum eSectionLead {
    General = 0,
    CustomDateFields = 1,
    CustomTextFields = 2,
    AdditionalMultilineTextFields = 3,
    RevenueRelatedFields = 4,
    CustomMoneyFields = 5,
    CustomClassificationDropDownFields = 6,
    CustomClassificationCheckboxFields = 7,
    None = -1
}

export enum eSectionCompany {
    General = 1,
    AddtionalInformation = 2,
    Communication = 3,
    ClassificationDropDown = 4,
    ClassificationCheckBox = 5,
    Comments = 6
}

export enum eFieldStatus {
    Show = 0,
    ShowMandatory = 1,
    Hide = 2
}

export enum eSection {
    Communication = 1,
    Address = 2,
    AddtionalInformation = 3,
    ClassificationDropDown = 4,
    ClassificationCheckBox = 5,
    Comments = 6,
    ImportantDates = 7,
    MoreFields = 8,
    General = 9
}

export interface Filters {
    FilterName: string;
    value: number;
    display: string;
    cLPCompanyID: number;
    sOrder: number;
    strValue: string;
}

export interface ContactFields {
    contactID: Field<number>;
    referralID: Field<number>;
    cLPUserID: Field<number>;
    cLPCompanyID: Field<number>;
    companyID: Field<number>;
    firstName: Field<string>;
    lastName: Field<string>;
    salutation: Field<string>;
    title: Field<string>;
    companyName: Field<string>;
    add1: Field<string>;
    add2: Field<string>;
    add3: Field<string>;
    city: Field<string>;
    state: Field<string>;
    zip: Field<string>;
    country: Field<string>;
    custom1: Field<string>;
    custom2: Field<string>;
    custom3: Field<string>;
    custom4: Field<string>;
    custom5: Field<string>;
    custom6: Field<string>;
    custom7: Field<string>;
    custom8: Field<string>;
    custom9: Field<string>;
    custom10: Field<string>;
    custom11: Field<string>;
    custom12: Field<string>;
    custom13: Field<string>;
    custom14: Field<string>;
    custom15: Field<string>;
    custom16: Field<string>;
    check1: Field<boolean>;
    check2: Field<boolean>;
    check3: Field<boolean>;
    check4: Field<boolean>;
    check5: Field<boolean>;
    check6: Field<boolean>;
    phone: Field<string>;
    homePhone: Field<string>;
    mobile: Field<string>;
    altPhone: Field<string>;
    fax: Field<string>;
    otherFax: Field<string>;
    eBlastAddress: Field<number>;
    email: Field<string>;
    email2: Field<string>;
    email3: Field<string>;
    webSite: Field<string>;
    class1Code: Field<number>;
    class2Code: Field<number>;
    class3Code: Field<number>;
    class4Code: Field<number>;
    class5Code: Field<number>;
    class6Code: Field<number>;
    class7Code: Field<number>;
    class8Code: Field<number>;
    comments: Field<string>;
    shareable: Field<boolean>;
    hasBeenEdited: Field<boolean>;
    outlookSync: Field<boolean>;
    dtModified: Field<string>;
    dtCreated: Field<string>;
    eVID: Field<number>;
    isOptOutTxtMsg: Field<number>;
    isOptOutEmail: Field<boolean>;
    custom17: Field<string>;
    custom18: Field<string>;
    custom19: Field<string>;
    custom20: Field<string>;
    cMSendImportDateAppt: Field<string>;
    //Contact More - Only show when Company.ShowMoreFields==true
    contactMoreFields: ContactMoreFields;
    displaySetting: DisplaySetting;
    verticalSectionDisplayOrder: VerticalSectionDisplayOrder[];
}

export interface ContactMoreFields {
    customDate1: Field<string>;
    customDate2: Field<string>;
    customDate3: Field<string>;
    customDate4: Field<string>;
    customDate5: Field<string>;
    customText1: Field<string>;
    customText2: Field<string>;
    customText3: Field<string>;
    customText4: Field<string>;
    customText5: Field<string>;
}

export interface VerticalSectionDisplayOrder {
    sectionName: string;
    sectionDisplayOrder: Number;
}

export interface ContactFieldsResponse extends SimpleResponse {
    contactFields: ContactFields;
    permission: Permission;
    vCardURL: string;
    mapURL: string;
    directionsURL: string;
    contactHistory: ContactHistory[];
}

export interface Permission extends SimpleResponse {
    canDelete: boolean;
    canView: boolean;
    canEdit: boolean;
}

export interface ContactExtended {
    cLPUserID: number;
    cLPCompanyID: number;
    referralID: number;
    firstName: string;
    lastName: string;
    salutation: string;
    title: string;
    companyID: number;
    companyName: string;
    add1: string;
    add2: string;
    add3: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    custom1: string;
    custom2: string;
    custom3: string;
    custom4: string;
    custom5: string;
    custom6: string;
    custom7: string;
    custom8: string;
    custom9: string;
    custom10: string;
    custom11: string;
    custom12: string;
    custom13: string;
    custom14: string;
    custom15: string;
    custom16: string;
    custom17: string;
    custom18: string;
    custom19: string;
    custom20: string;
    check1: boolean;
    check2: boolean;
    check3: boolean;
    check4: boolean;
    check5: boolean;
    check6: boolean;
    phone: string;
    homePhone: string;
    mobile: string;
    altPhone: string;
    fax: string;
    otherFax: string;
    email: string;
    email2: string;
    email3: string;
    eBlastAddress: number;
    webSite: string;
    class1Code: number;
    class2Code: number;
    class3Code: number;
    class4Code: number;
    class5Code: number;
    class6Code: number;
    class7Code: number;
    class8Code: number;
    eVID: number;
    comments: string;
    shareable: boolean;
    hasBeenEdited: boolean;
    outlookSync: boolean;
    isOptOutTxtMsg: number;
    isOptOutEmail: boolean;
    dtModified: Date;
    dtCreated: Date;
    userCode: string;
    uFirstName: string;
    uLastName: string;
    class1: string;
    class2: string;
    class3: string;
    class4: string;
    class5: string;
    class6: string;
    class7: string;
    class8: string;
    customDate1Title: string;
    customDate2Title: string;
    customDate3Title: string;
    customDate1: Date;
    customDate2: Date;
    customDate3: Date;
    customText1: string;
    customText2: string;
    customText3: string;
}

export interface fieldDiplaySetting {
    fieldName: string,
    displayOrder: number,
    sectionId: number,
    inputConfigFiled: string
}

export interface sectionDiplaySetting {
    sectionId: number,
    sectionName: string,
    sectionDisplayOrder: number
}

export interface DisplaySetting {
    fieldDiplaySettings: fieldDiplaySetting[],
    sectionDiplaySettings: sectionDiplaySetting[]
}

export interface DisplaySettingResponse {
    displaySetting: DisplaySetting,
    contactFields: Field<string>[]
}

export interface ContactHistoryListResponse {
    contactHistory: ContactHistory[]

}

export interface DisplaySettingsResponse extends SimpleResponse {
    diplaySettings: DisplaySetting;
}

export interface ContactLimitedFields {
    contactID: number,
    firstName: string,
    lastName: string,
    companyName: string,
    email: string,
    mobile: string,
    dtCreated: Date,
    dtModified: Date,
    name: string,
    mapURL: string,
    directionsURL: string,
    CompanyId: number;
    fax: string,
    isOptOutTxtMsg: eContactTxtMsgStatus,
    otherFax: string,
    isOptOutEmail: boolean,
    isHandled:boolean
}

export interface ContactListResponseLtd {
    contactList: ContactLimitedFields[]
}

export interface UserEmailList {
    email: string;
}

export interface UserEmailListResponse extends SimpleResponse {
    userEmailList: UserEmailList[];
}
export interface ContactRestore {
    contactsToRestore: number[];
    isRestoreAll: boolean;
    searchQuery: SearchQueryResponse;
}
export interface DuplicateContactsHeader {
    emailORMobile: string;
    count: number;
    subItems: DuplicateContactChild[];
}
export interface DuplicateContactChild {
    duplicateField: string;
    lastFirst: string;
    mobile: string;
    companyName: string;
    email: string;
    dtCreated: Date;
    contactID: number;
    userFullName: string;
}
export interface DuplicateContactsContainer {
    duplicateContactsHeaders: DuplicateContactsHeader[];

}

/*Manage Duplicate page*/
export interface MergeDuplicateContacts {
    keepContactID: number;
    MergeContactIDs: number[]
}
/*Manage Duplicate page*/

export interface Contact {
    contactID: number;
    referralID: number;
    cLPUserID: number;
    cLPCompanyID: number;
    companyID: number;
    firstName: string;
    lastName: string;
    salutation: string;
    title: string;
    companyName: string;
    add1: string;
    add2: string;
    add3: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    custom1: string;
    custom2: string;
    custom3: string;
    custom4: string;
    custom5: string;
    custom6: string;
    custom7: string;
    custom8: string;
    custom9: string;
    custom10: string;
    custom11: string;
    custom12: string;
    custom13: string;
    custom14: string;
    custom15: string;
    custom16: string;
    check1: boolean;
    check2: boolean;
    check3: boolean;
    check4: boolean;
    check5: boolean;
    check6: boolean;
    phone: string;
    homePhone: string;
    mobile: string;
    altPhone: string;
    fax: string;
    otherFax: string;
    eBlastAddress: number;
    email: string;
    email2: string;
    email3: string;
    webSite: string;
    class1Code: number;
    class2Code: number;
    class3Code: number;
    class4Code: number;
    class5Code: number;
    class6Code: number;
    class7Code: number;
    class8Code: number;
    comments: string;
    shareable: boolean;
    hasBeenEdited: boolean;
    outlookSync: boolean;
    dtModified: string;
    dtCreated: string;
    eVID: number;
    isOptOutTxtMsg: number;
    isOptOutEmail: boolean;
    custom17: string;
    custom18: string;
    custom19: string;
    custom20: string;
    uFirstName: string;
    uLastName: string;
    mailingId: number;
    status: number;
    requestComment: string;
    requestId: string;
    result: number;
    dialCode: string;
}

export interface ContactResponse extends SimpleResponse {
    contactList: Contact[];
}

export interface QuickContact {
    name: string;
    email: string;
    company: string;
    phone: string;
    address: string;
    title: string;
    website: string;
    clpCompanyID: number;
    clpUserID: number;

}

export interface PinnedContact extends Contact {
    ufirstName: string;
    ulastName: string;
    contactName: string;
    lastFirst: string;
    companyType: number;
    coCompanyName: string;

}

export interface PinnedContactListResponse extends SimpleResponse {
    pinnedContacts: PinnedContact[];
}

export interface ContactConnect {
    contactConnectID: number;
    contactID: number;
    relationship: string;
}

export interface ContactConnectData {
    contactID: number
    relationship: string
    firstName: string
    lastName: string
    email: string
    direction: string
}

export interface ContactConnect_GetListByOwner {
    contactConnectList: ContactConnectData[]
}

export interface LoadContactCallResponse extends SimpleResponse {
    dtStart: string,
    ddFromUser: [
        {
            value: string;
            text: string;
            isSelected: true;
        }];
    ddToContactNumber: [
        {
            value: string;
            text: string;
            isSelected: true;
        }];
    ddUserPhone: [
        {
            value: string;
            text: string;
            isSelected: true;
        }];
    voiceCallModel: VoiceCallModel;
    customPhone: string;
    userPhone: string;
    setupStatus: string;
}

//export interface ContactField extends SimpleResponse {
//  class1Code:number
//}

export interface ContactFieldResponse extends SimpleResponse {
    contactField: ContactField
}

export interface SkypeCall {
    skypeCallID: number;
    clpCompanyID: number;
    clpUserID: number;
    contactID: number;
    notes: string;
    dtCreated: string;
}

export interface SAMContactFieldsResponse extends SimpleResponse {
    sAMContactFields: SAMContactFields;
    permission: Permission;
    vCardURL: string;
    mapURL: string;
    directionsURL: string;
    contactHistory: ContactHistory[];
}

export interface SAMContactFields {
    contactID: SAMField<number>;
    referralID: SAMField<number>;
    cLPUserID: SAMField<number>;
    cLPCompanyID: SAMField<number>;
    companyID: SAMField<number>;
    firstName: SAMField<string>;
    lastName: SAMField<string>;
    salutation: SAMField<string>;
    title: SAMField<string>;
    companyName: SAMField<string>;
    add1: SAMField<string>;
    add2: SAMField<string>;
    add3: SAMField<string>;
    city: SAMField<string>;
    state: SAMField<string>;
    zip: SAMField<string>;
    country: SAMField<string>;
    custom1: SAMField<string>;
    custom2: SAMField<string>;
    custom3: SAMField<string>;
    custom4: SAMField<string>;
    custom5: SAMField<string>;
    custom6: SAMField<string>;
    custom7: SAMField<string>;
    custom8: SAMField<string>;
    custom9: SAMField<string>;
    custom10: SAMField<string>;
    custom11: SAMField<string>;
    custom12: SAMField<string>;
    custom13: SAMField<string>;
    custom14: SAMField<string>;
    custom15: SAMField<string>;
    custom16: SAMField<string>;
    check1: SAMField<boolean>;
    check2: SAMField<boolean>;
    check3: SAMField<boolean>;
    check4: SAMField<boolean>;
    check5: SAMField<boolean>;
    check6: SAMField<boolean>;
    phone: SAMField<string>;
    homePhone: SAMField<string>;
    mobile: SAMField<string>;
    altPhone: SAMField<string>;
    fax: SAMField<string>;
    otherFax: SAMField<string>;
    eBlastAddress: SAMField<number>;
    email: SAMField<string>;
    email2: SAMField<string>;
    email3: SAMField<string>;
    webSite: SAMField<string>;
    class1Code: SAMField<number>;
    class2Code: SAMField<number>;
    class3Code: SAMField<number>;
    class4Code: SAMField<number>;
    class5Code: SAMField<number>;
    class6Code: SAMField<number>;
    class7Code: SAMField<number>;
    class8Code: SAMField<number>;
    comments: SAMField<string>;
    shareable: SAMField<boolean>;
    hasBeenEdited: SAMField<boolean>;
    outlookSync: SAMField<boolean>;
    dtModified: SAMField<string>;
    dtCreated: SAMField<string>;
    eVID: SAMField<number>;
    isOptOutTxtMsg: SAMField<number>;
    isOptOutEmail: SAMField<boolean>;
    custom17: SAMField<string>;
    custom18: SAMField<string>;
    custom19: SAMField<string>;
    custom20: SAMField<string>;
    sAMContactMoreFields: SAMContactMoreFields;
    displaySetting: DisplaySetting;
    verticalSectionDisplayOrder: VerticalSectionDisplayOrder[];
}


export interface SAMField<T> {
    fieldName: string;
    fieldValue: T;
    fieldTitle: string;
    fieldType: eFieldType;
    isShow: eSAMFieldStatus;
    items: Filters[];
    isEditable: boolean;
    link: string;
    section: eSection;
    displayOrder: number;
    inputConfigFiled: string;
    sectionCompany: eSectionCompany;
    sectionLead: eSectionLead;
}

export interface SAMContactMoreFields {
    customDate1: SAMField<string>;
    customDate2: SAMField<string>;
    customDate3: SAMField<string>;
    customDate4: SAMField<string>;
    customDate5: SAMField<string>;
    customText1: SAMField<string>;
    customText2: SAMField<string>;
    customText3: SAMField<string>;
    customText4: SAMField<string>;
    customText5: SAMField<string>;
    customDate1Title: SAMField<string>;
    customDate2Title: SAMField<string>;
    customDate3Title: SAMField<string>;
    customDate4Title: SAMField<string>;
    customDate5Title: SAMField<string>;
}


export interface CheckRightsResponse extends SimpleResponse {
    isShowEdit: boolean;
    isShowDelete: boolean;
    isUnauthorize: boolean;
}

